import { render } from "./ResumeInfo.vue?vue&type=template&id=8a6486cc&scoped=true"
import script from "./ResumeInfo.vue?vue&type=script&lang=js"
export * from "./ResumeInfo.vue?vue&type=script&lang=js"

import "./ResumeInfo.vue?vue&type=style&index=0&id=8a6486cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a6486cc"]])

export default __exports__